import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ConversationSummary } from '../../../domain/models/conversation-summary.model';
import { ConversationListItemAction } from './conversation-list-item.component';

@Component({
  selector: 'talk-to-your-data-conversation-history',
  templateUrl: './conversation-history.component.html',
  styleUrls: ['./conversation-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationHistoryComponent {
  @Input() history: readonly ConversationSummary[] | null = [];
  @Input() selectedConversationId: string | null = null;
  @Output() conversationSelected = new EventEmitter<string>();
  @Output() readonly conversationSaved = new EventEmitter<string>();
  @Output() readonly conversationRenamed = new EventEmitter<{ conversationId: string; title: string }>();
  @Output() readonly conversationDeleted = new EventEmitter<string>();

  onMenuAction(action: ConversationListItemAction): void {
    switch (action.action) {
      case 'pin':
        this.conversationSaved.emit(action.conversationId);
        break;
      case 'rename':
        this.conversationRenamed.emit({ conversationId: action.conversationId, title: action.title });
        break;
      case 'delete':
        this.conversationDeleted.emit(action.conversationId);
        break;
    }
  }

  onConversationSelected(conversationId: string): void {
    this.conversationSelected.emit(conversationId);
  }

  trackByConversationId = (index: number, historyItem: ConversationSummary): string => {
    const conversationId = historyItem.conversationId ?? historyItem.id;

    return conversationId || String(index);
  };
}
